import {
   ICONS_MAP,
   PRIMARY_FILTER_OPTIONS,
} from '@forwardflow/constants/onboarding.constants'
import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'
import { Group, Select, MultiSelect } from '@forwardflow/ui-v2'
import { SelectProps } from '@mantine/core'
import { IFilterCriteria } from '@forwardflow/types/onboarding'
import { CloseIcon } from '@forwardflow/icons'

const renderSelectOption: SelectProps['renderOption'] = ({ option }) => (
   <Group flex="1" gap="xs">
      {ICONS_MAP[option.value as keyof typeof ICONS_MAP]}
      {option.label}
   </Group>
)

interface FilterRowProps {
   filterCriteria: IFilterCriteria
   onUpdate: (filter: IFilterCriteria) => void
   onRemove: () => void
   usedFields: Set<string>
}

export const FilterRow = ({
   filterCriteria,
   onUpdate,
   onRemove,
   usedFields,
}: FilterRowProps) => {
   const { stages, tags, sources, ponds } = useOnboardingStoreV2()

   const dataMap = {
      source: sources,
      stage: stages.map((stage) => stage.name),
      tags: tags,
      assigned_pond_id: ponds,
   }

   // Get available field options (exclude already used fields except the current one)
   const availableFieldOptions = PRIMARY_FILTER_OPTIONS.filter(
      (option) =>
         option.value === filterCriteria.field || !usedFields.has(option.value)
   )

   const handleFieldChange = (value: string | null) => {
      if (!value) return
      onUpdate({
         ...filterCriteria,
         field: value as 'source' | 'stage' | 'tags' | 'assigned_pond_id',
         value: [], // Reset values when field changes
      })
   }

   const handleValuesChange = (values: string[]) => {
      onUpdate({
         ...filterCriteria,
         value: values,
      })
   }

   return (
      <div className="grid grid-cols-[1fr_3fr_auto] gap-4 items-center">
         <Select
            key={`selectedField-${filterCriteria.field}`}
            leftSection={
               ICONS_MAP[filterCriteria.field as keyof typeof ICONS_MAP]
            }
            data={availableFieldOptions}
            renderOption={renderSelectOption}
            value={filterCriteria.field}
            onChange={handleFieldChange}
            placeholder="Select a field"
         />
         <MultiSelect
            key={`selectedValues-${filterCriteria.field}`}
            data={dataMap[filterCriteria.field as keyof typeof dataMap] || []}
            value={filterCriteria.value.map(String)}
            onChange={handleValuesChange}
            placeholder="Select values"
         />
         <CloseIcon width={16} height={16} onClick={onRemove} />
      </div>
   )
}
